import React from 'react';
import styled, { css } from 'styled-components';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { IGutterProps, useGutterCss } from '../../fundamentals/spaces/space';
import { BaseDiv } from '../../common/BaseElements';

export interface ITabPanelProps extends React.HTMLAttributes<HTMLDivElement>, IGutterProps {
  show?: boolean;
  disabled?: boolean;
}

const TabPanelContainer = styled(BaseDiv)<ITabPanelProps>`
  ${useGutterCss()};
  ${({ show }) =>
    !show &&
    css`
      display: none;
    `}
`;

export const TabPanel = React.forwardRef<HTMLDivElement, React.PropsWithChildren<ITabPanelProps>>(({ children, disabled, show, ...rest }, ref) => {
  const { generateTestId } = useTestId(rest, 'TabPanel');

  return (
    <TabPanelContainer ref={ref} {...generateTestId()} show={!disabled && show} {...rest}>
      {show && children}
    </TabPanelContainer>
  );
});
